module.exports = __webpack_public_path__ + "static/media/banner_1.2653be66.jpg";